import { HttpClient } from '@angular/common/http';
import { BOOL_TYPE } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { ArticleReportAPIModel } from './article-report-model';
declare var $;

@Component({
  selector: 'app-article-status-report',
  templateUrl: './article-status-report.component.html',
  styleUrls: ['./article-status-report.component.css']
})
/** articleStatus-report component*/
export class ArticleStatusReportComponent implements OnInit {
  modelItem = new ArticleReportAPIModel();
  public aMenuList = [];

  mywindow = null;
  journalList: any;
  issueList: any;
  volumeList: any;
  reportTypeList: any;


  PublisherList: any; TaskList: any; ReasonList: any;
  UserList: any; FilterUserList: any; UserLeadList: any;
  UserList1: any; UserList2: any;
  PraUserList: any; JournalList: any;

  dataTableReport: any;
  @ViewChild('dataTableReport', { static: false }) tableReport;
  dataSetReport: any;

  ngOnInit() {
    ApiMethod.getBaseUrl();
    $('#divFilterPanel').css('height', (GlobalConstants.size.height));
    $('#divFilter').css('height', (GlobalConstants.size.height) - 80);

    this.GetPublisherList();
    this.GetJournalList();
    this.GetUserLeadList();
    this.GetFilterUserList();
  }

  ngAfterViewChecked(): void {
    $('.spPopup').css('text-decoration', 'none');
  }

  /** articleStatus-report ctor */
  constructor(private router: Router, private http: HttpClient) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ArticleReportAPIModel>data["ArticleReportPage"];

        $(".select2").select2();


        $("#ddlFilterJournal,#ddlFilterAllocatedUser,#ddlFilterTaskName,#ddlFilterStatus").select2({
          placeholder: "Select", dropdownParent: "#divFilterPanel"
        });


        $("#lstJournals").select2({
          placeholder: "Select Journal", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstJournals").val([]).trigger("change");

        $("#lstVolume").select2({
          placeholder: "Select Volume", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstVolume").val([]).trigger("change");

        $("#lstIssue").select2({
          placeholder: "Select Issue", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstIssue").val([]).trigger("change");

        this.getJournalsList();
        this.getReportTypeList();

        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");

        customfunctions.SetDateValues("#txtFromDtList", "#txtToDtList");
        //this.GetReportDatafromType();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  //Get Report data list
  GetReportDatafromType() {
    let zcheck: boolean = false;

    var fromDate = $("#Txt_FromDate").val();//'01/01/2021';
    var toDate = $("#Txt_ToDate").val();
    if ($("#ddlReportType").val() == 0) {
      ngswal("Warning !", "Please select report type", "warning");
    }
    else {
      // Check Report Action 
      this.reportTypeList.forEach(reportType => {
        if (reportType.MenuName === $("#ddlReportType").val()) {
          const viewValue = reportType.Action.toLowerCase();
          if (viewValue.includes('excel')) {
            zcheck = true;
          }
        }
      });
    }
    if (zcheck) {
      this.ExcelReport();
    }
    else {
      $("#LoadingImage").show();


      let pubId = localStorage.aPubID;
      if ($("#ddlReportType").val() == 'PRA Services Report') {
        pubId = $('#ddlFilterPulisher').val();
        fromDate = $("#txtFromDtList").val();
        toDate = $("#txtToDtList").val();
      }

      var reportData = {
        LoginId: localStorage.aLoginID,
        PublisherId: pubId,
        FromDate: fromDate.toString(),
        ToDate: toDate.toString(),
        Journals: $("#lstJournals").val().toString(),
        Volume: $("#lstVolume option:selected").text(),
        Issue: $("#lstIssue option:selected").text(),
        ReportType: $("#ddlReportType").val(),
        SkipDateFilter: $('#chkSkipDate')[0].checked,
        DateType: $("#ddlFilterDateType").val(),
        AllocatedUser: $("#ddlFilterAllocatedUser").val() ? $("#ddlFilterAllocatedUser").val().join(',') : "All",
        JournalCode: $("#ddlFilterJournal").val() ? $("#ddlFilterJournal").val().join(',') : "All",
        TaskName: $("#ddlFilterTaskName").val() ? $("#ddlFilterTaskName").val().join(',') : "All",
        CurrentStatus: $("#ddlFilterStatus").val() ? $("#ddlFilterStatus").val().join(',') : "All",
        FeedbackType: $("#ddlFilterFeedbackType").val(),
      };

      $('#dataTableReport').DataTable().clear().destroy();
      $('#DataTables_Table_0').DataTable().destroy();
      $('#DataTables_Table_0').empty();

      ApiMethod.postMethod(this.modelItem.ArticleReportAPI, reportData).subscribe(
        result => {
          $('.jqTable').hide();
          $("#LoadingImage").hide();


          this.dataSetReport = JSON.stringify(result.aitemList);
          this.dataSetReport = JSON.parse(this.dataSetReport);
          this.dataTableReport = $(this.tableReport.nativeElement);

          //Dynamic datable
          let acolList = result.acolListL;
          let dataItem = new DataParam();
          dataItem.acolList = acolList;
          dataItem.aNewButtonName = '';
          dataItem.dataTable = this.dataTableReport;
          dataItem.dataset = this.dataSetReport;
          dataItem.dtheight = (GlobalConstants.size.height - 220);
          dataItem.modulename = $("#ddlReportType").val();
          dataItem.ExportFileName = $("#ddlReportType").val();
          dataItem.isDefault = false;

          if ($("#ddlReportType").val() == 'PRA Services Report') {
            dataItem.filterPanel = true;
          }
          else {
            dataItem.filterPanel = false;
          }

          if ($("#ddlReportType").val() == 'Awaiting XmlBooking') {
            dataItem.infoPopupID = 'IngestID';
          }
          if ($("#ddlReportType").val() == 'Production Datewise') {
            dataItem.FooterCallback = true;
            dataItem.FooterSummaryStartIndex = 2;
            dataItem.FooterSummaryEndIndex = 9;
          }

          this.dataTableReport = customfunctions.dynamicDataTable(dataItem);
          //Dynamic datable

        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }

  //Download Excel Report
  ExcelReport() {
    $('.jqTable').hide();
    var fromDate = $("#Txt_FromDate").val();//'01/01/2021';
    var toDate = $("#Txt_ToDate").val();
    $("#LoadingImage").show();
    var loginId = localStorage.aLoginID ? localStorage.aLoginID : 0;
    var publisherId = localStorage.aPubID ? localStorage.aPubID : 0;
    var fromDateStr = fromDate.toString() ? fromDate.toString() : "null";
    var toDateStr = toDate.toString() ? toDate.toString() : "null";
    var journals = $("#lstJournals").val().toString() ? $("#lstJournals").val().toString() : "null";
    var volume = $("#lstVolume option:selected").text() ? $("#lstVolume option:selected").text() : "null";
    var issue = $("#lstIssue option:selected").text() ? $("#lstIssue option:selected").text() : "null";
    var reportType = $("#ddlReportType").val() ? $("#ddlReportType").val() : "null";

    ApiMethod.Downloadfile(this.modelItem.ArticleExcelReportAPI + "/" + loginId + "/" + publisherId + "/" + fromDateStr + "/" + toDateStr
      + "/" + journals + "/" + volume + "/" + issue + "/" + reportType);
    $("#LoadingImage").hide();
  }

  getFiltered() {
    this.GetReportDatafromType();
  }

  resetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    this.GetReportDatafromType();
  }

  getJournalsList() {
    //var publisherId = 1;//$('#lstPublisher').val();
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + '/' + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getReportTypeList() {
    ApiMethod.getMethod(this.modelItem.ReportTypeAPI + "/" + localStorage.roleId).subscribe(
      result => {
        this.reportTypeList = result.areportType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  DownloadFile() {
    ApiMethod.Downloadfile(`api/DownloadIngestion/${localStorage.aEID}`);
  }

  ResetPopupFilter() {

    // Clear multiple-select dropdowns
    [
      '#ddlFilterAllocatedUser',
      '#ddlFilterJournal',
      '#ddlFilterTaskName',
      '#ddlFilterStatus'
    ].forEach(id => {
      $(id).val([]).trigger('change');
    });

    // Reset single-select dropdown
    $('#ddlFilterTeamLead').val(0).trigger('change');
  }

  ShowFilterPanel() {
    $('#divFilterPanel').show();
  }

  HideFilterPanel() {
    $('#divFilterPanel').hide();
  }


  GetPublisherList(): void {
    ApiMethod.getMethod('/api/pra/publist/' + localStorage.aLoginID).subscribe(
      result => {
        this.PublisherList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetJournalList() {
    $("#LoadingImage").show();
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherId: $('#ddlFilterPulisher').val(),
    };
    ApiMethod.postMethod('pra/PRAJournalConfig', dashboardPostData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.JournalList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }



  GetUserLeadList(): void {
    ApiMethod.getMethod('/api/pra/userlist/true/0').subscribe(
      result => {
        this.UserLeadList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  GetUserList(load = 0): void {
    let leadId = $('#ddlKPITeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/' + leadId).subscribe(
      result => {
        if (load == 1) {
          this.UserList1 = result.datalist;
        }
        if (load == 2) {
          this.UserList2 = result.datalist;
        }
        else {
          this.UserList = result.datalist;
          this.UserList1 = result.datalist;
          this.UserList2 = result.datalist;
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetFilterUserList(): void {
    let leadId = $('#ddlFilterTeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/' + leadId).subscribe(
      result => {
        this.FilterUserList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


}
